import { Badge } from "@mantine/core"
import classes from './PrimaryBadge.module.scss'
export const PrimaryBadge = (props) => {
    return <Badge className={classes.badge}>{props.children}</Badge>
}